export { contextModuleName as moduleName, rolePermissions } from '@shared';
export const maxProfiles = 8;
export const maxProfilesMobile = 6;
export const maxCouncilUnitsSuggestions = 3;
